import { TransactionRelationshipSelectOptions } from '@/modules/accounting/models/TransactionRelationshipSelectOptions';
import { transactionRelationshipSelectOptions } from '@/modules/accounting/store/accounting.state';

export function setTransactionRelationshipSelectOptions(
  options: TransactionRelationshipSelectOptions
): void {
  transactionRelationshipSelectOptions.value = options;
}
